import createChainedFunction from '@mui/utils/createChainedFunction';
export default createChainedFunction;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/createChainedFunction.js
// module id = 870
// module chunks = 25